import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { styled } from 'styled-components'

import Clickable from 'core/components/lib/Clickable'
import {
  boxShadow,
  onSurface,
  onSurfaceVariant,
  outline,
  primaryContainer,
  surfaceBright,
  surfaceBrightHover,
  surfaceDim,
} from 'core/styles'

export const FilterControlContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  align-items: stretch;
  overflow: hidden;
`

export const FilterTagsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: stretch;
  min-width: 0;
  max-width: 50vw;
  overflow: auto hidden;
  scrollbar-width: thin;
  scrollbar-color: ${outline} transparent;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: ${outline};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${onSurfaceVariant};
  }
`

export const FilterTag = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 4px;
  align-items: center;
  border: 1px solid ${outline};
  border-radius: 8px;
  background-color: ${surfaceDim};
  white-space: nowrap;
`

export const FilterTagLabel = styled.span`
  padding-left: 8px;
  color: ${onSurface};
  font-size: 14px;
  font-weight: 500;
`

export const FilterTagValue = styled.span`
  border-radius: 8px;
  background-color: ${primaryContainer};
  padding: 4px 12px;
  color: ${onSurface};
  font-size: 14px;
  font-weight: 500;
`

export const FilterTagRemove = styled(Clickable)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: solid 1px ${outline};
  border-radius: 0;
  cursor: pointer;
  width: 32px;
  height: 100%;
  color: ${onSurface};

  &:hover {
    opacity: 0.6;
  }
`

export const StyledDropdownContent = styled(DropdownMenu.Content)`
  box-sizing: border-box;
  z-index: 100;
  border: 1px solid ${outline};
  border-radius: 12px;
  box-shadow: ${boxShadow};
  background-color: ${surfaceBright};
  padding: 8px;
  width: auto;
  min-width: 400px;
`

export const StyledTrigger = styled(Clickable)`
  font-size: 14px;
  font-weight: 600;

  &[data-state='open'] {
    background-color: ${surfaceBrightHover};
  }
`

export const FiltersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${outline};
  border-radius: 8px;
`

export const DeleteButton = styled(Clickable)`
  border-radius: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 7px 8px;
  width: 36px;
  height: 32px;
`

export const AddFilterButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const StyledAddFilterButton = styled(Clickable)`
  font-size: 14px;
  font-weight: 500;
`

export const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  padding: 16px 0;
  color: ${onSurfaceVariant};
  font-size: 14px;
`

export const HorizontalDivider = styled.div`
  background-color: ${outline};
  width: 1px;
  height: 32px;
`
